import { Collapsible } from '../interfaces';
import { Entity } from './entity';
import { BaseStudy } from './base-study';

export class Study extends BaseStudy implements Collapsible {
  name: string;
  description: string;
  primaryEntity: Entity = new Entity();
  collapsed: boolean;
}
